// client/src/components/common/BrandLogo.jsx
import React from 'react';

/**
 * 品牌 Logo：默认使用站点自带 /logo.png（用户 2026-10-20 指定）。
 * 仅在用户未上传自定义 systemLogo 时作为默认 Logo 使用
 * （Navbar/Sidebar/Login 均优先渲染 settings.systemLogo，为空时落到本组件）。
 */
const BrandLogo = ({ size = 32 }) => {
  const radius = Math.round(size * 0.28);

  return (
    <img
      src="/logo.png"
      alt="logo"
      width={size}
      height={size}
      className="shrink-0 object-contain"
      style={{ borderRadius: radius }}
    />
  );
};

export default BrandLogo;
